module.exports = __webpack_public_path__ + "static/media/strzalka-link.41179c14.svg";